export default class TagFilteredCollectionList {
    static init() {
        const tagFilterForm = document.querySelector('.tag-filtered-collection-list')

        if (!tagFilterForm) {
            return;
        }

        new TagFilteredCollectionList(tagFilterForm)
    }

    get classes () {
        const node = 'tag-filtered-collection-list';
        const card = 'tag-filtered-collection-list__item';
        return {
            node: node,
            card: card,
            get items() {
                return node + '__items'
            },
            get hiddenItems() {
                return node + '__items--is-hidden'
            },
            get hiddenCard() {
                return card + '--is-hidden'
            },
            get filter() {
                return node + '__filter'
            },
            get message() {
                return node + '__message'
            },
            get hiddenMessage() {
                return node + '__message--is-hidden'
            },
            select: {
                get industry() {
                    return node + '__filter__select-industries'
                },
                get technology() {
                    return node + '__filter__select-technologies'
                },
                get country() {
                    return node + '__filter__select-countries'
                }
            }
        }
    }

    constructor(element) {
        if (!element) return;

        this.itemsWrapper = element.querySelector('.' + this.classes.items);
        this.cards = element.querySelectorAll('.' + this.classes.card);
        this.countrySelect = element.querySelector('.' + this.classes.select.country);
        this.industrySelect = element.querySelector('.' + this.classes.select.industry);
        this.technologySelect = element.querySelector('.' + this.classes.select.technology);
        this.message = element.querySelector('.' + this.classes.message);

        if (this.technologySelect) this.removeTechnologieFilterOptionsWithoutReferences();

        if (this.countrySelect) this.countrySelect.addEventListener('change', (e) => {
            this.showCards(this.filterCards());
        });

        if (this.industrySelect) this.industrySelect.addEventListener('change', (e) => {
            this.showCards(this.filterCards());
        });

        if (this.technologySelect) this.technologySelect.addEventListener('change', (e) => {
            this.showCards(this.filterCards());
        });
    }

    removeTechnologieFilterOptionsWithoutReferences() {
        this.technologySelect.querySelectorAll('option').forEach(option => {
            console.info(option.innerText, this.filterCardsBy(false, option.value, false).length)
            if(this.filterCardsBy(false, option.value, false).length === 0) {
                option.remove();
            }
        });
    }

    filterCards() {
        return this.filterCardsBy(
            this.countrySelect && this.countrySelect.value !== '' ? this.countrySelect.value : false,
            this.technologySelect && this.technologySelect.value !== '' ? this.technologySelect.value : false,
            this.industrySelect && this.industrySelect.value !== '' ? this.industrySelect.value : false,
        );
    }

    /**
     * False means no not filter by this value
     */
    filterCardsBy(filterByCountry, filterByTechnology, filterByIndustry) {
        return Array.prototype.filter.call(this.cards, card => {
            let filter = JSON.parse(card.dataset.filter) || {};
            let isInCardsCountries = filterByCountry === false || (filter.countries && filter.countries.indexOf(filterByCountry) !== -1);
            let isInCardsTechnologies = filterByTechnology === false || (filter.technologies && filter.technologies.indexOf(filterByTechnology) !== -1);
            let isInCardsIndustries = filterByIndustry === false || (filter.industries && filter.industries.indexOf(filterByIndustry) !== -1);

            return isInCardsCountries && isInCardsTechnologies && isInCardsIndustries;
        });
    }

    showCards(cards) {
        this.message.classList[cards.length === 0 ? 'remove' : 'add'](this.classes.hiddenMessage);
        this.itemsWrapper.classList[cards.length === 0 ? 'add' : 'remove'](this.classes.hiddenItems);

        this.hideCards(this.excludeFilter());

        Array.prototype.forEach.call(cards, card => {
            card.classList.remove(this.classes.hiddenCard)
        });
    }

    hideCards(cards) {
        Array.prototype.forEach.call(cards, card => {
            card.classList.add(this.classes.hiddenCard)
        });
    }

    excludeFilter() {
        return Array.prototype.filter.call(this.cards, el => !this.filterCards().includes(el));
    }
}
